import React, { useEffect, useState } from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import image from '../Assets/About1.png'
import Detailsslider from '../Components/Detailsslider'
import { FaBed, FaBath, FaRulerCombined, FaRegBuilding } from "react-icons/fa";
import { BsWhatsapp } from "react-icons/bs";
import { IoMdCall } from 'react-icons/io'
import { apiPost, Get_Api } from '../ApiUrls'
import { useNavigate, useParams } from 'react-router-dom'
import PropertyLocation from '../Components/PropertyLocation'
import { toast } from 'react-toastify'
import ContactModal from '../Components/ContactModal'
import { FaDownload } from "react-icons/fa";
import EnquiryModel from '../Components/EnquiryModel'


function PropertyDetails() {
    const { id } = useParams()
    const [SliderImage, setSliderImage] = useState([])
    const [Propertiesdetail, setPropertiesdetail] = useState(null);
    const [IsUploading, setIsUploading] = useState(false);

    const GetAllPropertiesdetail = async () => {
        try {
            setIsUploading(true)
            const response = await Get_Api(`api/admin/GetAProperties/${id}`)
            setPropertiesdetail(response?.data || [{ Image: image }])
            setIsUploading(false)
        } catch (error) {
            setIsUploading(false)
            console.log(error)
        }
    }

    useEffect(() => {
        if (Propertiesdetail !== null) {
            const formattedImages = Propertiesdetail?.AllImages?.map(img => ({ Image: img }));
            setSliderImage(formattedImages);
        }
    }, [Propertiesdetail]);


    useEffect(() => {
        GetAllPropertiesdetail();
    }, [id]);


    const navigate = useNavigate();

    const [EnquiryAbout, setEnquiryAbout] = useState('');
    const [Message, setMessage] = useState('');

    const handleCheckboxChange = (event) => {
        const { value } = event.target;
        setEnquiryAbout(value);
    };

    const handleMessageChange = (event) => {
        setMessage(event.target.value);
    };

    const UserCreateEnquiry = async () => {
        if (!EnquiryAbout || !Message) {
            toast.error('EnquiryAbout and Message are required!');
            return;
        }
        try {
            let data = {
                EnquiryAbout,
                Message,
                Property: id
            }
            setIsUploading(true)
            const response = await apiPost(`api/user/CreateUserPropertyenquiry`, data)
            toast.success(response?.message);
            setEnquiryAbout('')
            setMessage('')
            navigate('/')
            setIsUploading(false)
        } catch (error) {
            setIsUploading(false)
            toast.error(error?.response?.data?.message);
            console.log(error)
        }
    }

    const [isLoggedIn, setIsLoggedIn] = useState(false);


    useEffect(() => {
        const storedUser = localStorage.getItem("user") || {};
        const storedToken = localStorage.getItem("userToken");
        if (storedUser && storedToken) {
            setIsLoggedIn(true);
        }
    }, []);

    const [ShowContactForm, setShowContactForm] = useState(false);

    const OpenContactForm = () => {
        setShowContactForm(true)
    }
    const CloseContactForm = () => {
        setShowContactForm(false)
    }

    // const downloadFile = (url, filename) => {
    //     const link = document.createElement("a");
    //     link.href = url;
    //     link.setAttribute("download", filename); // Set the filename
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    //   };
    const downloadFile = (url, filename = "brochure.pdf") => {
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <>
            <Navbar />
            <div className="PropertiesDetails-header">
                <h1>Serene Suburban</h1>
                <p>
                    Home  /Properties /<span className="active"> {Propertiesdetail?.Name} </span>
                </p>
            </div>
            <br />
            <Detailsslider slides={SliderImage} />
            <br />
            <div className="property-container">
                <div className='mainheader'>
                    <div className="listing-header">
                        <h1 className="listing-title">{Propertiesdetail?.Name}</h1>
                        <br />
                        <p className="listing-location">📍 {Propertiesdetail?.Address} {Propertiesdetail?.PinCode}</p>
                        <br />
                        <div className="details">
                            <span><FaBed /> {Propertiesdetail?.Room} BedRoom</span>
                            <span><FaBath /> {Propertiesdetail?.Bath} BathRoom</span>
                            <span><FaRulerCombined /> {Propertiesdetail?.SquareFeet} Sq.ft</span>
                            <span><FaRegBuilding /> {Propertiesdetail?.Floor} Floor</span>
                        </div>
                    </div>
                </div>
                <div className="property-container">
                    {/* <div className="property-location">
                        <h2>Property Location</h2>
                        <p>You’ll get the exact location after booking a visit</p>
                        <PropertyLocation lat={Propertiesdetail?.Lat} lng={Propertiesdetail?.Long} />
                    </div> */}

                    <div className="property-description">
                        <h2>Property Description</h2>
                        <br />
                        <p>
                            {Propertiesdetail?.ProPertyDescription &&
                                (isExpanded
                                    ? Propertiesdetail.ProPertyDescription
                                    : Propertiesdetail.ProPertyDescription.slice(0, 500))}

                            {Propertiesdetail?.ProPertyDescription &&
                                Propertiesdetail.ProPertyDescription.length > 500 && (
                                    <span
                                        className="read-more cursor-pointer text-blue-600 font-medium ml-2"
                                        onClick={() => setIsExpanded(!isExpanded)}
                                    >
                                        {isExpanded ? "Read Less" : "Read More"}
                                    </span>
                                )}
                        </p>
                    </div>
                </div>
                <div className="amenities-container">
                    <h2>Amenities</h2>
                    <div className="amenities-grid">
                        {Propertiesdetail?.Amenities?.map((item, index) => (
                            <div key={index} className="amenity-card">
                                <img src={item.Image} style={{ width: '50px', height: '50px' }} />
                                <p>{item.Name}</p>
                            </div>
                        ))}
                    </div>
                    {
                        isLoggedIn ?
                            <div className="enquiry-box">
                                <h3>Have more questions about the property?</h3>
                                <div className="property-infodetail">
                                    <img src={image} alt="Property" />
                                    <div>
                                        <h4>Serene Suburban</h4>
                                        <p>Florida, Ram Maruti Road, Civil Hospital, 400080</p>
                                        <strong>21,000.00 USD</strong>
                                    </div>
                                </div>

                                <div className="enquiry-options">
                                    <label>
                                        <input
                                            type="radio"
                                            name="enquiry"
                                            value="Scheduling an Inspection"
                                            checked={EnquiryAbout === 'Scheduling an Inspection'}
                                            onChange={handleCheckboxChange}
                                        />
                                        Scheduling an Inspection
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="enquiry"
                                            value="Price Information"
                                            checked={EnquiryAbout === 'Price Information'}
                                            onChange={handleCheckboxChange}
                                        />
                                        Price Information
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="enquiry"
                                            value="Rates & Fees"
                                            checked={EnquiryAbout === 'Rates & Fees'}
                                            onChange={handleCheckboxChange}
                                        />
                                        Rates & Fees
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="enquiry"
                                            value="Similar Properties"
                                            checked={EnquiryAbout === 'Similar Properties'}
                                            onChange={handleCheckboxChange}
                                        />
                                        Similar Properties
                                    </label>
                                </div>

                                <textarea
                                    placeholder="Write your message..."
                                    value={Message}
                                    onChange={handleMessageChange}
                                />


                                <button onClick={() => { UserCreateEnquiry() }} className="send-button">{IsUploading ? "Please Wait" : "Send Enquiry "}</button>
                            </div>
                            :
                            <button onClick={() => { OpenContactForm() }} className="send-button"> Send Enquiry</button>
                    }
                </div>
                <div className="property-container">
                    <h2>Gallary</h2>
                    <div className="property-gallery-slider">
                        <div className="property-gallery-container">
                            <div className="property-gallery-track">
                                {Propertiesdetail?.Gallary?.map((img, index) => (
                                    <div key={`property-gallery-${index}`} className="property-gallery-slide">
                                        <img src={img} alt={`Property Image ${index + 1}`} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="property-container">
                    <div className="download-container">
                        <h2 className="download-title">
                            It’s a lot more than a home. It’s a lifestyle.
                            <br />
                            Everything you need to live a life filled with joy.
                        </h2>
                        <div className="download-buttons">
                            <button className="download-btn"
                                onClick={() => downloadFile(Propertiesdetail?.Brochure, "Brochure")}
                            >
                                Download Brochure <FaDownload className="download-icon" />
                            </button>
                            <button className="download-btn"
                                onClick={() => downloadFile(Propertiesdetail?.Video, "Video")}
                            >
                                Project Video <FaDownload className="download-icon" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <EnquiryModel
                isOpen={ShowContactForm}
                onClose={CloseContactForm}
                selectedProperty={id}
            />

            <Footer />
        </>
    )
}

export default PropertyDetails